<div class="button-group">
    <button class="switch-btn" [class.active]="isRouteActive('/calling-screen/calling-screen') || isRouteActive('/calling-screen/calling-screen-beta')"
        (click)="navigateToDismissal_CS()">{{'calling-screen.btn-group-switch.dismissal' | translate}}</button>
    <button class="switch-btn" [class.active]="isRouteActive('/bus-calling-screen/bus-calling-screen')"
        (click)="navigateToBus_CS()">{{'calling-screen.btn-group-switch.bus' | translate}}</button>
</div>